var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.3 162.3",
    style: {
      enableBackground: "new 0 0 162.3 162.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.85;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#94989D;}\r\n\t.st3{fill:#35CC62;}\r\n\t.st4{fill:#CC3737;}\r\n\t.st5{fill:#E89A1C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,162.3C36.4,162.3,0,125.9,0,81.2S36.4,0,81.2,0s81.2,36.4,81.2,81.2S125.9,162.3,81.2,162.3z M81.2,2 C37.5,2,2,37.5,2,81.2s35.5,79.2,79.2,79.2s79.2-35.5,79.2-79.2S124.8,2,81.2,2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,124.9l-7.7-2.7l0.1-0.7c0.9-4.5-1.7-9.1-6-10.6s-9.2,0.4-11.3,4.5L59,116l-7.7-2.7 c-1.2-0.4-1.9-1.8-1.4-3L75,38.9c0.4-1.2,1.8-1.9,3-1.4l7.7,2.7l-0.1,0.7c-0.9,4.5,1.7,9.1,6,10.6s9.2-0.4,11.3-4.5l0.3-0.6 L111,49c1.2,0.4,1.9,1.8,1.4,3l-25.1,71.4C86.9,124.6,85.5,125.3,84.3,124.9z M78.4,121.1l6.4,2.2c0.4,0.1,0.8-0.1,0.9-0.4 l25.1-71.4c0.1-0.4-0.1-0.8-0.4-0.9l-6.4-2.2c-2.6,4.4-8.1,6.4-13,4.7c-4.9-1.7-7.9-6.7-7.2-11.8L77.5,39 c-0.4-0.1-0.8,0.1-0.9,0.4l-25.1,71.4c-0.1,0.4,0.1,0.8,0.4,0.9l6.4,2.2c2.6-4.4,8.1-6.4,13-4.7C76.1,111,79.1,116,78.4,121.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.7,59.6c-0.3,0.7,0.1,1.5,0.8,1.7l2.7,1c0.7,0.3,1.5-0.1,1.7-0.8c0.3-0.7-0.1-1.5-0.8-1.7l-2.7-1 C86.8,58.5,86,58.9,85.7,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,56.7c-0.3,0.7,0.1,1.5,0.8,1.7l2.7,1c0.7,0.3,1.5-0.1,1.7-0.8c0.3-0.7-0.1-1.5-0.8-1.7l-2.7-1 C78.5,55.6,77.8,56,77.5,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.2,55.6l2.7,1c0.7,0.3,1.5-0.1,1.7-0.8c0.3-0.7-0.1-1.5-0.8-1.7l-2.7-1C70.4,52.8,69.5,55.3,70.2,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94,62.5c-0.3,0.7,0.1,1.5,0.8,1.7l2.7,1c0.7,0.3,1.5-0.1,1.7-0.8s-0.1-1.5-0.8-1.7l-2.7-1 C95,61.4,94.2,61.8,94,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,65.4c-0.3,0.7,0.1,1.5,0.8,1.7l2.7,1c0.7,0.3,1.6-2.3,0.9-2.6l-2.7-1C103.2,64.3,102.4,64.7,102.1,65.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95,72.4c0.6,0.2,1,0.9,0.7,1.5l-11.1,31.6c-0.2,0.6-0.9,1-1.5,0.7l-19.2-6.8c-0.6-0.2-1-0.9-0.7-1.5 l11.1-31.6c0.2-0.6,0.9-1,1.5-0.7L95,72.4 M95.6,70.9l-19.2-6.8c-1.5-0.5-3.1,0.3-3.6,1.7L61.6,97.4c-0.5,1.5,0.3,3.1,1.7,3.6 l19.2,6.8c1.5,0.5,3.1-0.3,3.6-1.7l11.1-31.6C97.8,73,97,71.4,95.6,70.9L95.6,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.1,74.2l-7.2,20.6c-0.3,0.7,0.1,1.5,0.8,1.7c0.7,0.3,1.5-0.1,1.7-0.8l7.2-20.6c0.3-0.7-0.1-1.5-0.8-1.7 S79.3,73.5,79.1,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,92.6l-1.4,4.1c-0.3,0.7,0.1,1.5,0.8,1.7c0.7,0.3,1.5-0.1,1.7-0.8l1.4-4.1c0.3-0.7-0.1-1.5-0.8-1.7 C79.8,91.6,79,91.9,78.7,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.5,76.2l-3.9,11c-0.3,0.7,0.1,1.5,0.8,1.7s1.5-0.1,1.7-0.8l3.9-11c0.3-0.7-0.1-1.5-0.8-1.7 C85.6,75.1,84.8,75.5,84.5,76.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketInfoWhite);
export default __webpack_public_path__ + "static/media/TicketInfo_white.10ad4bfae4ff0de05a5e9caee411d14e.svg";
export { ForwardRef as ReactComponent };